export const ifftDocs = {
  name: 'ifft',
  category: 'Matrix',
  syntax: [
    'ifft(x)'
  ],
  description: 'Calculate N-dimensional inverse Fourier transform',
  examples: [
    'ifft([[2, 2], [0, 0]])'
  ],
  seealso: [
    'fft'
  ]
}
